import styled from "styled-components";

export const Container = styled.div`
  padding: 1.5rem 0;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.2;
  text-align: center;
`;
